import moment from 'moment';
import { Module } from 'vuex';

import { DateFormat } from '@/constants/dateFormat';
import BookingService from '../../../../services/landing/booking.service';
import { BookingStoreInterface } from '@/types/store/landing/booking/bookingStoreInterface';
import { CustomerDataInterface } from '@/types/store/landing/booking/customerDataInterface';
import { BookingDataInterface } from '@/types/store/landing/booking/bookingDataInterface';
import { BookingDetailsInterface } from '@/types/store/landing/booking/bookingDetailsInterface';
import { PaymentMethods } from '@/constants/paymentMethods';

export const booking_data_default: BookingDataInterface = {
  room_type_hid: '',
  meal_option: 0,
  checkin: moment(moment().add(1, 'days')).format(DateFormat.VueDate),
  checkout: moment(moment().add(2, 'days')).format(DateFormat.VueDate),
  guests_number: 1,
  rooms_number: 1,
};

export const customer_data_default = {
  name: '',
  email: '',
  phone: '',
  address: '',
  prefecture_code: 0,
};
export const booking_details_default: BookingDetailsInterface = {
  payment_method: PaymentMethods.CC,
  total_amount: 0,
  use_discount: false,
};
const getDefaultState = () => {
  return {
    initial: booking_data_default,
    data: booking_data_default,
    customer: customer_data_default,
    customerBackup: customer_data_default,
    bookingDetails: booking_details_default,
  };
};

const bookingStore: Module<BookingStoreInterface, any> = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setInitBooking(state, data) {
      if (data.checkin.indexOf('/') === -1) {
        data.checkin = moment(data.checkin).format(DateFormat.VueDate);
      }
      if (data.checkout.indexOf('/') === -1) {
        data.checkout = moment(data.checkout).format(DateFormat.VueDate);
      }
      state.initial = { ...state.initial, ...data };
    },
    setBooking(state, data: BookingDataInterface = booking_data_default) {
      state.data = data;
    },
    setCustomer(state, data: CustomerDataInterface = customer_data_default) {
      state.customer = data;
    },
    setCustomerBackup(state, data: CustomerDataInterface = customer_data_default) {
      state.customerBackup = data;
    },
    setBookingDetails(state, data: BookingDetailsInterface = booking_details_default) {
      state.bookingDetails = data;
    },
    setDiscountStatus(state, data: boolean) {
      state.bookingDetails.use_discount = data;
    },
  },
  actions: {
    createBooking(context, data) {
      return BookingService.createBooking(data);
    },
    rejectBookingRequest(context, id) {
      return BookingService.rejectBookingRequest(id);
    },
    authorizeCharge(context, data) {
      return BookingService.authorizeCharge(data);
    },
    passwordInputScreenGMO(context, data) {
      return BookingService.passwordInputScreenGMO(data.url, data.params);
    },
    resetState({ commit, dispatch }, booking_data: BookingDataInterface = booking_data_default) {
      commit('setInitBooking', booking_data);
      commit('setBooking');
      commit('setCustomer');
      commit('setCustomerBackup');
      commit('setBookingDetails');
    },
  },
};

export default bookingStore;
